import {onFind} from "../libs/@elements/init-modules-in-scope";
import {on, hasClass, removeClass, findIn} from "../libs/@elements/dom-utils";

export function init() {
    onFind('.js-ajax-form', function ($element) {
        on('fetch.ajax-form', function () {
            let offset = $element.getBoundingClientRect().top + window.pageYOffset;

            if (window.pageYOffset > offset) {
                try {
                    window.scroll({
                        top: offset,
                        behavior: 'smooth'
                    });
                } catch (e) {
                    window.scrollTo(0, offset)
                }
            }
        }, $element);
    });
}
